import { render, staticRenderFns } from "./ListLocalVotacion.vue?vue&type=template&id=df5fc59a&scoped=true&"
import script from "./ListLocalVotacion.vue?vue&type=script&lang=js&"
export * from "./ListLocalVotacion.vue?vue&type=script&lang=js&"
import style0 from "./ListLocalVotacion.vue?vue&type=style&index=0&id=df5fc59a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5fc59a",
  null
  
)

export default component.exports